import { useDraggable } from '@dnd-kit/core';

export const DraggableItem = ({ id, children, type }: { id: string; children: React.ReactNode; type?: string }) => {
    const { attributes, listeners, setNodeRef, isDragging } = useDraggable({ id });

    return (
        <div
            ref={setNodeRef}
            {...attributes}
            {...listeners}
            className={`${type === 'linked' ? 'linked-block__item' : 'basic-elements__item'} ${
                isDragging ? 'dragging' : ''
            }`}
            style={{
                cursor: 'grab',
                opacity: isDragging ? 0.5 : 1,
                transform: isDragging ? 'scale(1.05)' : 'none',
                transition: 'transform 0.2s ease'
            }}
        >
            {children}
        </div>
    );
};
